import { Gem, RefreshCw } from "lucide-react";

import { PageHeader, btn, Loader } from "@/components/Page";
import { useMiningDashboard } from "@/hooks/useMiningDashboard";
import { MiningTabs } from "@/components/mining/MiningTabs";
import { MiningSummaryPanel } from "@/components/mining/MiningSummaryPanel";
import { MiningResourcesPanel } from "@/components/mining/MiningResourcesPanel";
import { MiningDiscoveryRewardsPanel } from "@/components/mining/MiningDiscoveryRewardsPanel";
import { MiningEquipmentLink } from "@/components/mining/MiningEquipmentLink";

export default function MiningRewards() {
  const { data, loading, loadMining, milestoneBusyKey, handleClaimMilestone, liveSmithing } = useMiningDashboard();

  if (loading && !data) return <Loader label="Loading Discovery Rewards..." />;

  return (
    <div data-testid="mining-rewards-page" className="space-y-6">
      <PageHeader
        title="Discovery Rewards"
        subtitle="Claim milestone rewards from your rare finds and unlock new mining recipes and projects."
        action={
          <button data-testid="mining-rewards-refresh-button" type="button" onClick={() => loadMining()} className={btn("ghost") + " flex items-center gap-2"}>
            <RefreshCw size={15} /> Refresh
          </button>
        }
      />

      <MiningEquipmentLink />

      <MiningTabs claimableCount={data?.discoveries?.claimable_count || 0} />


      <div className="grid xl:grid-cols-[1fr_1fr] gap-6">
        <MiningSummaryPanel profile={data?.profile} smithing={liveSmithing || data?.smithing} />
        <MiningResourcesPanel profile={data?.profile} showHistory={false} />
      </div>

      <MiningDiscoveryRewardsPanel
        discoveries={data?.discoveries}
        milestoneBusyKey={milestoneBusyKey}
        onClaimMilestone={handleClaimMilestone}
      />
    </div>
  );
}